module.exports = __webpack_public_path__ + "632d43e344dc545fe7f3bb084063cb18.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/347379__gevaroy__bells-1.wav
// module id = 838
// module chunks = 0